import { buildProps } from '@jdesign-vue/utils'
import { componentSizes } from '@jdesign-vue/constants'
import type Tag from './tag.vue'

import type { ExtractPropTypes } from 'vue'

export const tagProps = buildProps({
  /**
   * @description type of Tag
   */
  type: {
    type: String,
    values: [
      'success',
      'info',
      'warning',
      'error',
      '',
      'gray',
      'yellow',
      'fuchsia',
      'cyan',
    ],
    default: '',
  },
  /**
   * @description whether Tag can be removed
   */
  closable: Boolean,
  /**
   * @description whether to disable animations
   */
  disableTransitions: {
    type: Boolean,
    default: true,
  },
  /**
   * @description whether Tag has a highlighted border
   */
  hit: Boolean,
  /**
   * @description background color of the Tag
   */
  color: {
    type: String,
    default: '',
  },
  textColor: {
    type: String,
    default: '',
  },
  borderColor: {
    type: String,
    default: '',
  },
  /**
   * @description size of Tag
   */
  size: {
    type: String,
    values: componentSizes,
    default: '',
  },
  /**
   * @description theme of Tag
   */
  effect: {
    type: String,
    values: ['dark', 'light', 'plain', 'vivid'],
    default: 'light',
  },
  /**
   * @description whether Tag is rounded
   */
  round: Boolean,
  iconTop: {
    type: Boolean,
    default: false,
  },
} as const)
export type TagProps = ExtractPropTypes<typeof tagProps>

export const tagEmits = {
  close: (evt: MouseEvent) => evt instanceof MouseEvent,
  click: (evt: MouseEvent) => evt instanceof MouseEvent,
}
export type TagEmits = typeof tagEmits

export type TagInstance = InstanceType<typeof Tag>
